import { Children, FC, ReactNode, useEffect } from 'react';

interface DocumentTitleProps {
    children: ReactNode;
}

const DocumentTitle: FC<DocumentTitleProps> = (props) => {
    const { children } = props;

    useEffect(() => {
        let title = 'ProgressCenter';

        if (children) {
            const prependTitle = Children.toArray(children).reduce((acc, cur) => {
                acc += cur.toString();

                return acc;
            }, '');

            title = `${prependTitle} | ProgressCenter`;
        }

        document.title = title;

        // return () => {
        //     document.title = 'ProgressCenter';
        // };
    }, [children]);

    return null;
};

export default DocumentTitle;
